import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, finalize, first, map } from 'rxjs/operators';
import { User } from '../models/auth.models';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ColaboratorService } from 'src/app/pages/projects/services/colaborators.service';
import { SoapService } from './soap.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    // TOKEN REFRESH VARS
    isRefreshing = false;
    $isRefreshing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    // END TOKEN REFRESH VARS

    private user: User | null = null;
    private colaborator: any | null = null;
    private activeTaskId: number | null = null;

    constructor(
        private http: HttpClient,
        private colaboratorService: ColaboratorService,
        private soapService: SoapService,
    ) {
    }

    /**
     * Returns the current user
     */
    get currentUser() {
        return this.user;
    }
    get currentActiveTaskId() {
        return this.activeTaskId;
    }
    get currentColaborator() {
        return this.colaborator;
    }

    /**
     * Performs the login auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string): any {        
        return this.soapService.requestLogin('authenticate_user', {
            user_name: email,
            user_password: password,
            version: '6.0.0'
        }).pipe(
            map(user => {
                // login successful if there's a jwt token in the response
                if (user[0] && user[0].sessionid) {
                    // store user details and jwt in session
                    /* user.data[0].payload.token = user.data[0].accessToken;
                    user.data[0].payload.expiresIn = new Date(Date.now() + user.data[0].expiresIn); */
                    let currentDate = new Date();

                    // Add 1 hour to the current date
                    currentDate.setHours(currentDate.getHours() + 1);
                    this.user = new User();
                    this.user.id = user[0].id;
                    this.user.firstName = user[0].user_name;
                    this.user.expiresIn = currentDate;
                    this.user.token = user[0].sessionid;
                    this.user.technicianid = user[0].technicianid;
                    this.user.admin = user[0].admin == "0" ? false : true;
                    this.user.use_products = user[0].use_products === "1" ? true : false;
                    /* this.colaboratorService.getColaboratorOfUser(new User(user.data[0].payload).id).subscribe((response: any) => {
                        this.colaborator = response.data[0];
                    }) */
                    localStorage.setItem('ExpandBSSLoginUser', JSON.stringify(this.user))
                    this.setRefreshingToken(false);
                }else{
                    user=false;
                }

                return user;
            })
        )

    }



    /* return this.http.post<any>(`${environment.API_URL}/api/auth/login`, { email, password }, {
        headers: new HttpHeaders().append('ignore401', 'true'),
        withCredentials: true
    })
        .pipe(map(user => {
            // login successful if there's a jwt token in the response
            if (user.data[0] && user.data[0].accessToken) {
                // store user details and jwt in session
                user.data[0].payload.token = user.data[0].accessToken;
                user.data[0].payload.expiresIn = new Date(Date.now() + user.data[0].expiresIn);
                this.user = new User(user.data[0].payload);
                this.colaboratorService.getColaboratorOfUser(new User(user.data[0].payload).id).subscribe((response: any) => {
                    this.colaborator = response.data[0];
                })
                this.setRefreshingToken(false);
            }
    
            return user;
        })); 
    }
    */
    /**
     * Logout the user
     */
    logout(): void {
        // remove user from session storage to log user out
        // sessionStorage.removeItem('currentUser');
        this.user = null;
        localStorage.removeItem('ExpandBSSLoginUser')
    }

    logoutAPI() {
        return this.http.get(environment.API_URL + `/api/auth/logout`, {
            withCredentials: true
        }
        );
    }

    recoverPassword(data: any) {
        return this.http.post<any>(environment.API_URL + `/api/auth/passwordRecovery`, data, { headers: this.headers })
    }

    passwordReset(data: any) {
        return this.http.post<any>(environment.API_URL + `/api/auth/passwordReset`, data, { headers: this.headers })
    }


    /**
     * Refresh Token
     * Gets a new access token from the refreshtoken present in the cookies
     */
    refreshToken(ignore401: boolean = false): Observable<any> {

        // TODO Change this       
        let teste = localStorage.getItem('ExpandBSSLoginUser')
        if (teste) {
            this.user = JSON.parse(teste)
        }
        if (this.currentUser) {
            return of(true);
        } else {
            return of(false);
        }

        return new Observable((observer) => {

            this.setRefreshingToken(true);

            return this.http.post<any>(`${environment.API_URL}/api/auth/refreshToken`, {}, {
                headers: {
                    'no-error': 'true',
                    'no-token': 'true',
                    'ignore401': ignore401 ? 'true' : 'false',
                },
                withCredentials: true
            })
                .pipe(
                    first(),
                    finalize(() => {
                        //console.log("EMT refresh token FALSE");
                        this.setRefreshingToken(false);
                    })
                )
                .subscribe((result) => {
                    // const current = this.currentUser();
                    // if (current) {
                    //     current.token = result.data[0].accessToken;
                    //     current.expiresIn = new Date(Date.now() + result.data[0].expiresIn);
                    // }
                    // sessionStorage.setItem('currentUser', JSON.stringify(current));

                    if (result && result.data && result.data.length > 0) {
                        this.user = new User(result.data[0].payload);
                        this.user.token = result.data[0].accessToken;
                        this.user.expiresIn = new Date(Date.now() + result.data[0].expiresIn);
                        this.colaboratorService.getColaboratorOfUser(new User(result.data[0].payload).id).subscribe((response: any) => {
                            this.colaborator = response.data[0];
                        })
                        observer.next(result);
                        observer.complete();
                    }
                }, (error) => {
                    observer.error(error);
                    observer.complete();
                });
        });
    }

    initialRefreshToken(): Observable<any> {
        return this.refreshToken().pipe(catchError(() => of(true)));
    }

    private setRefreshingToken(isRefreshing: boolean) {
        this.isRefreshing = isRefreshing;
        this.$isRefreshing.next(this.isRefreshing);
    }

    hasPermission(permission: string): boolean {
        if (this.user) {
            return this.user.permissions.includes(permission);
        } else return false;
    }

    checkPermissions(permissions: string | string[]): boolean {
        if (permissions) {
            if (Array.isArray(permissions)) {
                let resp = false;
                permissions.forEach(permission => {
                    if (this.hasPermission(permission)) {
                        resp = true;
                    }
                });

                return resp;
            } else {
                return this.hasPermission(permissions);
            }
        } else return false;
    }

    setActiveTask(taskId: number | null) {
        this.activeTaskId = taskId
    }

}



